export default __webpack_public_path__ + "static/media/number2.d235bd72.webp";